<template>
  <Header />
  <VueQueryDevtools />
  <main class="app">
    <NuxtLayout name="container">
      <slot></slot>
    </NuxtLayout>
    <Footer />
  </main>
</template>
<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  flex-direction: column;
  flex-grow: 1
  // min-height: 100vh;
}
</style>
